$(document).on("paste", "#crud_review_caption_template_modal .textarea, #crud_review_caption_template_modal .text-input", function(e) {
  e.preventDefault();
  const clipboard = (e.originalEvent || e).clipboardData;
  const html = clipboard.getData("text/html");

  if (html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    document.execCommand("insertHTML", false, sanitizePastedContent(temp));
  } else {
    document.execCommand("insertText", false, clipboard.getData("text/plain"));
  }
});

function sanitizePastedContent(element) {
  let result = "";
  for (const node of element.childNodes) {
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName === "SPAN" && node.getAttribute("contenteditable") === "false" && node.id) {
        result += node.outerHTML;
      } else if (node.tagName === "BR") {
        result += "<br>";
      } else if (node.tagName === "DIV" || node.tagName === "P") {
        const inner = sanitizePastedContent(node);
        if (inner) result += "<div>" + inner + "</div>";
      } else {
        result += sanitizePastedContent(node);
      }
    }
  }
  return result;
}

$(document).on("click", "#crud_review_caption_template_modal .dropdown .dropdown-item", function() {
  const $dropdown = $(this).closest(".dropdown");
  const targetSelector = $dropdown.data("target");
  const $textarea = $(targetSelector);
  const textarea = $textarea[0];
  
  // Get current selection and range
  const selection = window.getSelection();
  const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

  // Create span element for the tag
  const span = document.createElement("span");
  span.setAttribute("contentEditable", "false"); 
  span.setAttribute("id", $(this).data("id"));
  span.textContent = $(this).text();

  // Handle tag insertion
  if (range && textarea.contains(range.commonAncestorContainer)) {
    // Insert at cursor position if selection is in textarea
    range.insertNode(span);
    // Add space after span
    const space = document.createTextNode("\u00A0");
    span.after(space);
  } else {
    // Otherwise append to end of textarea
    textarea.appendChild(span);
    // Add space after span
    const space = document.createTextNode("\u00A0");
    span.after(space);
  }

  // Move cursor after inserted space
  const newRange = document.createRange();
  const spaceNode = span.nextSibling;
  newRange.setStartAfter(spaceNode);
  newRange.setEndAfter(spaceNode);
  selection.removeAllRanges();
  selection.addRange(newRange);

  // Scroll textarea to show inserted tag if at end
  if (textarea.scrollWidth > textarea.clientWidth) {
    textarea.scrollLeft = textarea.scrollWidth;
  }

  // Sync content with hidden input
  syncContent($textarea);
});

$(document).on("input", "#crud_review_caption_template_modal .textarea, #crud_review_caption_template_modal .text-input",function() {
  syncContent($(this));
});

$(document).on("click", "#select-all-networks", function() {
  const $select = $("#social-networks");
  const allOptions = $select.find("option").map(function() {
    return $(this).val();
  }).get();
  
  $select.val(allOptions).trigger("change");
  
  // Update button text to show "Deselect All"
  $(this).html('Tout désélectionner');
  $(this).attr("id", "deselect-all-networks");
  
  // Check form fields after selection
  checkFormFields();
});

// Deselect all social networks button
$(document).on("click", "#deselect-all-networks", function() {
  const $select = $("#social-networks");
  $select.val([]).trigger("change");
  
  // Update button text to show "Select All"
  $(this).html('Tout sélectionner');
  $(this).attr("id", "select-all-networks");
  
  // Check form fields after deselection
  checkFormFields();
});

// Check fields on input change
$(document).on('input change', '#crud_review_caption_template_modal :input, #crud_review_caption_template_modal .text-input, #crud_review_caption_template_modal .textarea', function() {
  checkFormFields();
});

function syncContent(target) {
  const modalSelector = "#crud_review_caption_template_modal";
  const templateContent = $(target.attr("data-target"), modalSelector);
  const textAreaContent = $(target, modalSelector).html();


  const updatedContent = textAreaContent
    // Replace <span contenteditable="false" id="...">...</span> with {id}
    .replace(/<span contenteditable="false" id="([^"]+)">[^<]*<\/span>/g, (match, id) => `{${id}}`)
    .replace(/<br>/g, '\n')
    .replace(/\r/g, '')
    .trim();

  // Set the value in the template content
  templateContent.val(updatedContent);
}

$(document).on("click", ".select2-results__option", function() {
  if($("#social-networks").val().includes("gmb")) {
    $("#gmb-btn-container").removeClass("d-none");
  } else {
    $("#gmb-btn-container").addClass("d-none");
  }
});

// Check at modal load
$(document).on("shown.bs.modal", ".modal#crud_review_caption_template_modal", function() {
  checkFormFields();
});

// Function to check if all required fields are filled
function checkFormFields() {
  const titleFilled = $("input#review_caption_template_title")?.val()?.length > 0;
  const captionFilled = $("input#initial-caption-textarea")?.val()?.length > 0;
  const socialNetworksFilled = $("select#social-networks")?.val()?.length > 0;
  const gmbBtnType = $("#gmb_btn_type")?.val();
  const gmbBtnValue = $("#initial-gmb-btn-value")?.val();

  let validated;

  if(gmbBtnType === "learn_more") {
    validated = titleFilled && captionFilled && socialNetworksFilled && gmbBtnValue;
  } else {
    validated = titleFilled && captionFilled && socialNetworksFilled;
  }

  if(validated) {
    $("#crud_review_caption_template_modal button[type=submit]").removeAttr("disabled");
  } else {
    $("#crud_review_caption_template_modal button[type=submit]").attr("disabled", true);
  }
}

$(document).on("change", "#gmb_btn_type", function() {
  if ($(this).val() === "learn_more") {
    $("#crud_review_caption_template_modal .gmb-btn").removeClass("d-none");
    $("#crud_review_caption_template_modal .gmb-btn-call-notice").addClass("d-none");
  } else if ($(this).val() === "call") {
    $("#crud_review_caption_template_modal .gmb-btn").addClass("d-none");
    $("#crud_review_caption_template_modal .gmb-btn-call-notice").removeClass("d-none");
  } else {
    $("#crud_review_caption_template_modal .gmb-btn").addClass("d-none");
    $("#crud_review_caption_template_modal .gmb-btn-call-notice").addClass("d-none");
  }
});